const toggleDisabledState = (
  allChecked: boolean,
  submitButton: HTMLElement,
) => {
  if (allChecked) {
    submitButton.removeAttribute("disabled");
  } else {
    submitButton.setAttribute("disabled", "disabled");
  }
};

export const manageTermsAndConditions = () => {
  const checkboxGroups = document.querySelectorAll<HTMLInputElement>(
    "[data-form-terms-and-conditions]",
  );

  // Group all associated checkboxes to the same submit button
  const groupedButtons = new Map<string, HTMLElement>();
  checkboxGroups.forEach((checkbox) => {
    const targetSubmitButtonId = checkbox.dataset.submitButtonId;
    if (!targetSubmitButtonId) return;
    const submitButton = document.getElementById(targetSubmitButtonId);
    if (!submitButton) return;
    if (!groupedButtons.has(targetSubmitButtonId)) {
      groupedButtons.set(targetSubmitButtonId, submitButton);
    }
  });

  groupedButtons.forEach((submitButton, submitButtonId) => {
    const relatedCheckboxes = document.querySelectorAll<HTMLInputElement>(
      '[data-form-terms-and-conditions][data-submit-button-id="' +
        submitButtonId +
        '"]',
    );

    const updateButtonState = () => {
      const allChecked = Array.from(relatedCheckboxes).every(
        (checkbox) => checkbox.checked,
      );
      toggleDisabledState(allChecked, submitButton);
    };
    updateButtonState();

    relatedCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", updateButtonState);
    });
  });
};
